import { htmlSafe } from '@ember/template';
import Component from '@glimmer/component';
import { PrismCard, PrismIcon } from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';
import type { IllustrationName } from '@mylighthouse/prism-ember/types/components/prism/illustration';
import { ILLUSTRATIONS_MAP } from '@mylighthouse/prism-foundation';

interface GeneralCardWithIllustrationSignature {
  Args: {
    description: string;
    icon?: IconName;
    illustration?: IllustrationName;
    title: string;
  };
  Blocks: {
    footer: [];
  };
  Element: HTMLDivElement;
}

export default class GeneralCardWithIllustration extends Component<GeneralCardWithIllustrationSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get illustrationHTML() {
    if (this.args.illustration === undefined) {
      return '';
    }

    if (!ILLUSTRATIONS_MAP[this.args.illustration]) {
      return '';
    }

    return htmlSafe(ILLUSTRATIONS_MAP[this.args.illustration]);
  }

  <template>
    <PrismCard @contentLayout="noPadding" ...attributes>
      <:content>
        <div class="flex flex-col gap-300 p-400">
          {{#if this.illustrationHTML}}
            <div
              class="w-max"
              data-test-id="card-with-illustration-illustration"
            >
              {{this.illustrationHTML}}
            </div>
          {{else if @icon}}
            <div class="bg-level-3 rounded-circle w-max p-200">
              <PrismIcon
                @name={{@icon}}
                data-test-id="card-with-illustration-icon"
              />
            </div>
          {{/if}}

          <h4 data-test-id="card-with-illustration-title">{{@title}}</h4>

          <p
            class="paragraph-300--regular"
            data-test-id="card-with-illustration-description"
          >
            {{@description}}
          </p>
        </div>
      </:content>
      <:footer>
        {{yield to="footer"}}
      </:footer>
    </PrismCard>
  </template>
}
